const hashCode = (s: string): number => {
  let hash = 0;
  const { length } = s;
  for (let index = 0; index < length; index += 1) {
    // eslint-disable-next-line no-bitwise
    hash = Math.trunc((hash << 5) - hash + s.charCodeAt(index));
  }
  return hash;
};

export default hashCode;
